import React, {Component} from 'react';
import {Col, Row, Typography, Alert, Switch, Select} from "antd";
import {t} from '../../../constant/i18n';
import {THEME} from '../../../constant/theme';


const {Title, Text} = Typography;

class ContactTel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            choixSelect: (localStorage.getItem('order_deja_contact')) ? localStorage.getItem('order_deja_contact') : 'null',
        }
    }
    componentDidMount() {

        if(localStorage.getItem('order_deja_contact') && localStorage.getItem('order_deja_contact') === 'non') {
           // this.setState({})
        }

    }

    handleChange = (value) => {

        this.setState({choixSelect: value});

        if (value === 'null') {
            localStorage.removeItem("order_deja_contact");
        } else {
            localStorage.setItem("order_deja_contact", value);
        }

    }

    render() {
        return (
            <div className="center">
                <div className="centerTxt mb10 mt10">
                    <Title level={3}>{t('contactTel.previousContact')}</Title>
                </div>

                <Row>
                    <Col span={24}>
                        <Select
                            defaultValue={this.state.choixSelect}
                            style={{
                                width: 120,
                            }}
                            onChange={this.handleChange}
                            options={[
                                {
                                    value: 'null',
                                    label: t('contactTel.choice'),
                                },
                                {
                                    value: 'oui',
                                    label: t('contactTel.yes'),
                                },
                                {
                                    value: 'non',
                                    label: t('contactTel.no'),
                                },
                            ]}
                        />
                        <br/>
                        <br/>
                        {(this.state.choixSelect === 'non') ? <Alert
                            message={<><div>{t('contactTel.bookAppt')}<a href={THEME.urls.appointment} target='_blank'>{THEME.urls.appointment}</a></div> <div>{t('contactTel.whileWaiting')}</div></>}
                            type="info"
                        /> : ''}
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ContactTel;